module.exports = "<app-layout>\n  <div class=\"container\">\n    <div class=\"inner\">\n      <h1 class=\"mat-title\">Manage Countries</h1>\n      <breadcrumbs [getDataFn]=\"breadcrumbsFN\"></breadcrumbs>\n      <synthrone-table #countryTable activeRouting=\"/countries\" [configColumns]=\"configColumns\" [getDataFromNewApiFn]=\"sdCountries\"></synthrone-table>\n    </div>\n  </div>\n</app-layout>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/views/countries-view/countries-view.component.html
// module id = ./src/app/components/views/countries-view/countries-view.component.html
// module chunks = main